export const getNavigationItem = (link) => {
    const splittedLink = link.split('/');
    return splittedLink.at(-1)?.trim() || splittedLink.at(-2)?.trim() || '';
};
